<template>
    <b-modal size="md"
             centered
             hide-footer
             v-model="value"
             v-on:hide="hideModal"
             v-on:cancel="hideModal"
             v-on:close="hideModal">
        <template v-slot:modal-title>
            <strong>
                忘記密碼
            </strong>
        </template>


    </b-modal>
</template>

<script>
import {
    BModal,
    BAvatar,
} from "bootstrap-vue";

export default {
    name: "ModalForgetPassword",
    components: {
        BModal,
        BAvatar,
    },
    props: {
        "value": {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {

        };
    },
    computed: {
        user () {
            return this.$store.state.user.user;
        },

        userRole () {
            return this.$store.state.user.user.role;
        },
    },
    methods: {
        hideModal () {
            this.$emit("input", false);
        },
    },
}
</script>

<style lang="scss" scoped>

</style>
